module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/icon_licensing-9474865ed56fae459d42c8ab9d24650e.png";